import styles from './index.module.css'
export default function Campains() {
	const NYTELSE = 'https://www.nytelse.no/tt/?tt=12509_2239549_263403_&amp;r='
	return (
		<>
			<article className={styles.section} style={{background: 'none'}}>
				<h1>Rabattkoder og tilbud</h1>
				<p>
					Oppdag hemmelighetene bak lukrative tilbud på sexleketøy fra Norges mest populære nettbutikker! 
					Vår rabattkupongside gir deg eksklusive muligheter til å utforske et bredt utvalg av intime produkter 
					til reduserte priser. Utfyll ditt private liv med spennende nytelser og skap uforglemmelige øyeblikk uten 
					å tømme lommeboken. Finn de beste tilbudene fra de største nettsidene for sexleketøy i Norge, og gjør 
					dine innerste fantasier til virkelighet uten å gå på kompromiss med kvaliteten. Nyt diskret levering og 
					en trygg kjøpsopplevelse, alt mens du sparer penger. Grip sjansen til å berike ditt erotiske eventyr 
					med våre eksklusive rabatter - tiden er inne for å ta glede til et helt nytt nivå!
				</p>
			</article>
			<section className={styles.section}>
				<h2>Rabattkoder Nytelse.no</h2>
				Klikk på denne <a href="https://www.nytelse.no/tt/?tt=12509_12_263403_rabattkodebsl25&r=%2F" target="_blank" rel="nofollow">lenken</a> og benytt kode: <strong>BSL25</strong> for å få 15% rabatt på alle kjøp over 500kr.<br/>
				<br/><span style={{fontSize: '.9em'}}>Koden gjelder alle kjøp over 500kr, og kan ikke kombineres med andre tilbud.
				<br/>Varemerket Womanizer er unntatt rabattkoder pga. avtale med leverandør.</span><br/><br/>
				<a href="/rabattkoder/nytelse" title="Om nytelse rabattkode." style={{fontSize: '.9em'}}>Les mer om rabattkoden her.</a>
			</section>
			<section className={styles.section}>
				<h2>Rabattkoder MerLykke.no</h2>
				Klikk på denne <a href="https://www.partner-ads.com/no/klikbanner.php?partnerid=30465&bannerid=110964" target="_blank" rel="nofollow noopener">lenken</a> og benytt kode: <strong>Sexleker25</strong> for å få 15% rabatt på hele bestillingen.<br/>
			</section>	<br/>
			<section className={styles.section} style={{background: '#eee', color: 'gray'}}>
				<h2>Rabattkoder Joyful.no</h2>
				<em>Ingen rabattkoder for øyeblikket.</em>
			</section>						
			<section className={styles.section} style={{background: '#eee', color: 'gray'}}>
				<h2>Rabattkoder Kondomeriet.no</h2>
				<em>Ingen rabattkoder for øyeblikket.</em>
			</section>
			<section className={styles.section} style={{background: '#eee', color: 'gray'}}>
				<h2>Rabattkoder Sinful.no</h2>
				<em>Ingen rabattkoder for øyeblikket.</em>
			</section>			
		</>
	)
}